import { render, staticRenderFns } from "./follow-up-tab.vue?vue&type=template&id=1d61e33a&scoped=true"
import script from "./follow-up-tab.vue?vue&type=script&lang=js"
export * from "./follow-up-tab.vue?vue&type=script&lang=js"
import style0 from "./follow-up-tab.vue?vue&type=style&index=0&id=1d61e33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61e33a",
  null
  
)

export default component.exports